import * as React from 'react';

import type ScheduleBoardWorkOrderVM from 'ab-socketModels/viewModels/scheduleBoard/scheduleBoardWorkOrder.viewModel';

import { Button } from '@acceligentllc/storybook';

import Dropdown from 'af-components/Controls/Dropdown';
import LabelWithColor from 'af-components/LabelWithColor';

interface OwnProps {
	assignmentNumber: number;
	createAssignment: (index: number, workOrder: ScheduleBoardWorkOrderVM) => void;
	removeAssignment: (index: number) => void;
	workOrders: ScheduleBoardWorkOrderVM[];
}

type Props = OwnProps;

const AssignableResourceAssignment: React.FC<Props> = (props: Props) => {
	const { createAssignment, removeAssignment, assignmentNumber, workOrders } = props;

	const renderWorkOrderOption = React.useCallback((option: ScheduleBoardWorkOrderVM) => {
		return (
			<div>
				<div>{option.code}</div>
				<LabelWithColor
					color={option.crewTypeColor}
					text={<span className="text-grey">{option.crewTypeName}</span>}
				/>
			</div>
		);
	}, []);

	const onCreateAssignment = React.useCallback(async (workOrder: ScheduleBoardWorkOrderVM) => {
		createAssignment(assignmentNumber, workOrder);
	}, [assignmentNumber, createAssignment]);

	const onRemoveAssignment = React.useCallback(() => {
		removeAssignment(assignmentNumber);
	}, [assignmentNumber, removeAssignment]);

	const unlockedWorkOrders = React.useMemo(() => workOrders.filter((_wo) => !_wo.locked), [workOrders]);

	return (
		<div
			className="schedule-board-modal__resource__assignment"
			key={`assignmentForm-${assignmentNumber}`}
		>
			<Dropdown<ScheduleBoardWorkOrderVM>
				containerClassName="schedule-board-modal__resource__assignment__dropdown"
				disabled={!unlockedWorkOrders.length}
				id={`assignmentForm-${assignmentNumber}`}
				isWhite={true}
				onValueChange={onCreateAssignment}
				options={unlockedWorkOrders}
				placeholder={!unlockedWorkOrders.length ? 'No available WorkOrders' : ''}
				renderMenuItem={renderWorkOrderOption}
				valueKey="id"
				withCaret={true}
			/>
			<Button
				icon="Delete"
				onClick={onRemoveAssignment}
				style="link-danger"
				tooltip="Delete"
			/>
		</div>
	);
};

export default React.memo(AssignableResourceAssignment);
